import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';

import BaseLayout from './layouts/BaseLayout';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/Login';
import StartBuilding from './pages/StartBuilding';
import SavedProjects from './pages/SavedProjects';
import Categories from './pages/Categories';
import SetupGuides from './pages/SetupGuides';
import CodeExtractor from './pages/CodeExtractor';
import DropboxCallback from './pages/DropboxCallback';
import Settings from './pages/Settings';

function App() {
  return (
    <AppProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<BaseLayout />}>
            <Route index element={<StartBuilding />} />
            <Route path="start-building" element={<StartBuilding />} />
            <Route path="saved-projects" element={<SavedProjects />} />
            <Route path="categories" element={<Categories />} />
            <Route path="setup-guides" element={<SetupGuides />} />
            <Route path="tool-code-extractor" element={<CodeExtractor />} />
            <Route path="oauth/dropbox/callback" element={<DropboxCallback />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Route>
      </Routes>
    </AppProvider>
  );
}

export default App;